import { render } from "./Refsolution.vue?vue&type=template&id=930887f4"
import script from "./Refsolution.vue?vue&type=script&lang=js"
export * from "./Refsolution.vue?vue&type=script&lang=js"

import "./Refsolution.vue?vue&type=style&index=0&id=930887f4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__